import React from 'react';

import moment from 'moment';

import DateRangePicker from 'components/DateRangePicker';
import Input from 'components/Input';
import CustomSelect, { RenderProps as CustomSelectRenderProps } from 'components/Selects/CustomSelect';
import TextArea from 'components/TextArea';
import CurrencyInput from 'containers/CurrencyInput';
import useStoreTranslation from 'hooks/useStoreTranslation';

import Types from '../Types';
import { Header, Title, CalendarIcon, StyledField as Field } from './styles';

const ExpenseValues = () => {
  const { t } = useStoreTranslation();

  const handleDateSetFieldValue = ({ initialDate }: { initialDate: Date }) => initialDate;

  const handleDateSetValue = (date: Date) => (date ? moment(date).format('DD/MM/YYYY') : '');

  return (
    <>
      <Header>
        <Title>{t('expense.values.title')}</Title>
      </Header>
      <Field name="value" label={t('expense.values.value.label')}>
        <CurrencyInput placeHolder={t('expense.values.value.placeHolder')} />
      </Field>
      <Field name="date" label={t('expense.values.date.label')}>
        <CustomSelect
          placeHolder={t('expense.values.date.placeHolder')}
          icon={<CalendarIcon />}
          onSetValue={handleDateSetValue}
          onSetFieldValue={handleDateSetFieldValue}
        >
          {({ value, ...selectProps }: CustomSelectRenderProps) => (
            <DateRangePicker {...selectProps} allDate onlyDate currentInitialDate={value} />
          )}
        </CustomSelect>
      </Field>
      <Field name="name" label={t('expense.values.establishment.label')}>
        <Input placeholder={t('expense.values.establishment.placeHolder')} />
      </Field>
      <Field name="type" label={t('expense.values.type.label')}>
        <Types
          options={[
            {
              label: t('expense.values.type.food'),
              value: 'Food',
              icon: 'food',
            },
            {
              label: t('expense.values.type.transport'),
              value: 'Transport',
              icon: 'transport',
            },
            {
              label: t('expense.values.type.accommodation'),
              value: 'Accommodation',
              icon: 'accommodation',
            },
            {
              label: t('expense.values.type.others'),
              value: 'Others',
              icon: 'others',
            },
          ]}
        />
      </Field>
      <Field name="chargeCode" label={t('expense.values.cost.label')}>
        <Input placeholder={t('expense.values.cost.placeHolder')} />
      </Field>
      <Field style={{ marginBottom: 36 }} name="comments" label={t('expense.values.comments.label')}>
        <TextArea placeholder={t('expense.values.comments.placeHolder')} />
      </Field>
    </>
  );
};

export default ExpenseValues;
